export default __webpack_public_path__ + "static/media/icon-team-builder.b885fb58.svg";